/**
 * Chrome 在 ResizeObserver 同帧内触发布局时会抛出该 “error”，
 * 业务通常无害，但 CRA / webpack-dev-server 开发态 overlay 会当成运行时崩溃。
 * 主拦截在 public/index.html（早于 overlay 注册）；此处作业务包内兜底。
 */
const RESIZE_OBSERVER_LOOP_RE = /ResizeObserver loop/i;

const isResizeObserverNoise = (event) => {
	if (!event) return false;
	let msg = event.message || event.error?.message || '';
	if (typeof event.reason === 'string') msg = msg || event.reason;
	if (event.reason?.message) msg = msg || event.reason.message;
	return typeof msg === 'string' && RESIZE_OBSERVER_LOOP_RE.test(msg);
};

if (typeof window !== 'undefined') {
	window.addEventListener(
		'error',
		(event) => {
			if (!isResizeObserverNoise(event)) return;
			event.stopImmediatePropagation();
			event.preventDefault();
		},
		true,
	);
}
